module.exports = __webpack_public_path__ + "public/Icons/18Reviews.svg?9d09ceba";